export const AddressIcon = ({ primaryFontColor = '#3b4046', style = {}, className = "" }) => {
  return (
    <svg
      id="location"
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      style={style}
      className={className}
    >
      <circle
        id="Ellipse_1333"
        data-name="Ellipse 1333"
        cx="12"
        cy="12"
        r="12"
        fill={primaryFontColor}
      />
      <path
        id="Path_64716"
        data-name="Path 64716"
        d="M23.452,25.78a.732.732,0,0,1-1.163,0l-3.464-4.8C16.671,18,18.987,14,22.871,14s6.2,4,4.046,6.981Z"
        transform="translate(-11.131 -8.283)"
        fill="#fff"
      />
      <circle
        id="Ellipse_1334"
        data-name="Ellipse 1334"
        cx="2.096"
        cy="2.096"
        r="2.096"
        transform="translate(9.658 7.771)"
        fill={primaryFontColor}
      />
    </svg>
  );
};
